$(function() {
    $('.select-all').on('change', function() {
        const dataTarget = $(this).data('target');
        if ($(this).is(':checked')) {
            $(dataTarget).attr('checked', 'checked');
        } else {
            $(dataTarget).removeAttr('checked');
        }
    });
});